import React from "react";
import SocialShare from "@/components/SocialShare";

const B = process.env.REACT_APP_BACKEND_URL;

export default function IssueShare({ issue }) {
  return <SocialShare prefix="issue" url={`${B}/api/share/issues/${issue.slug}`} text={`${issue.title} — Under the Lens, National Public Service Trust`} />;
}
